import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProposalCard = ({ proposal, onAccept, onReject, onViewDetails }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2
    })?.format(amount);
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })?.format(new Date(date));
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'new':
        return 'bg-primary/10 text-primary';
      case 'pending':
        return 'bg-warning/10 text-warning';
      case 'accepted':
        return 'bg-success/10 text-success';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'new':
        return 'Yeni Teklif';
      case 'pending':
        return 'İnceleniyor';
      case 'accepted':
        return 'Kabul Edildi';
      default:
        return 'Bilinmiyor';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
          <Image 
            src={proposal?.artistImage} 
            alt={proposal?.artistImageAlt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-1">{proposal?.artistName}</h3>
              <p className="text-sm text-muted-foreground">{proposal?.campaignTitle}</p>
            </div>
            <span className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getStatusColor(proposal?.status)}`}>
              {getStatusText(proposal?.status)}
            </span>
          </div>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <span className="flex items-center gap-1">
              <Icon name="Calendar" size={14} />
              {formatDate(proposal?.deadline)}
            </span>
            <span className="flex items-center gap-1">
              <Icon name="Music" size={14} />
              {proposal?.genre}
            </span>
          </div>
        </div>
      </div>
      <div className="bg-muted/50 rounded-lg p-4 mb-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Teklif Edilen Ücret</p>
            <p className="text-xl font-bold text-primary">{formatCurrency(proposal?.offer)}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">İçerik Türü</p>
            <div className="flex flex-wrap gap-1">
              {proposal?.deliverables?.map((item, index) => (
                <span key={index} className="px-2 py-1 bg-background rounded text-xs font-medium text-foreground">
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-4">
        <p className="text-sm text-muted-foreground mb-2">Kampanya Detayları:</p>
        <p className="text-sm text-foreground line-clamp-2">{proposal?.description}</p>
      </div>
      <div className="flex items-center gap-2">
        <Button 
          variant="default" 
          iconName="Check" 
          iconPosition="left"
          onClick={() => onAccept(proposal?.id)}
          className="flex-1"
        >
          Kabul Et
        </Button>
        <Button 
          variant="outline" 
          onClick={() => onViewDetails(proposal?.id)}
          className="flex-1"
        >
          Detayları Gör
        </Button>
        <Button 
          variant="ghost" 
          iconName="X"
          onClick={() => onReject(proposal?.id)}
        >
        </Button>
      </div>
    </div>
  );
};

export default ProposalCard;